import EAIcon from 'components/common/EAIcon';
import useStyles from "./ScoresStyle";
import clsx from 'clsx';

const GlobalScoreGauge = ({ data, scoreName, maxScore, folderName, getScoreByValue, clazz }) => {
  const { classes } = useStyles();

  const scorePerformance = getScoreByValue(data[scoreName]);

  const getChartIcon = (scorePerformance, folderName) => {
    return `${folderName}/gauge_${scorePerformance}`;
  };

  return (
      <div className={clsx(classes.globalScoreChart, clazz)}>
        <EAIcon icon={getChartIcon(scorePerformance, folderName)} />
        <div className={classes.globalScore}>
          <span className="score">{data[scoreName]}</span>
          {maxScore && <span className="max-score">{maxScore}</span>}
        </div>
      </div>
  );
};

export default GlobalScoreGauge;
